import React, { useEffect } from 'react';
import { ArrowRight } from 'lucide-react';
import { Header, Footer } from '../Common';
import HeroBanner from '@ajat/design-system/ContentBlocks/HeroBanner';
import Fullwidth from '@ajat/design-system/ContentBlocks/Fullwidth';
import USP from '@ajat/design-system/ContentBlocks/USP';
import useMenuItemNavigation from '../../../../hooks/useMenuItemNavigation';
import '../../Common/Landing/Landing.css';

/* ══════════════════════════════════════════════════════════════════════════
 * CLS-SE Landing Page
 * A brochure (2026-11-02, owner's decision): hero, USP, ONE Fullwidth, footer — no product
 * grids (the former Kollektion / Overalls & More blocks and their listing fetches are gone).
 * Responsive: mobile-first, desktop ≥ 1024px
 * ══════════════════════════════════════════════════════════════════════════ */
const Landing = () => {
  /* Set global brand on mount, restore previous on unmount */
  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', 'CLS');
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, []);

  // Menu-item click resolver (school shop / popup / fallback / closed page) for the hero CTA.
  const onMenuItemClick = useMenuItemNavigation({ brandSlug: 'clsse', feSlug: 'cls-se' });

  return (
    <div className="landing">
      {/* ── Header ── */}
      <Header
        showTopBar={false}
      />

      {/* ── Hero Banner ── */}
      <HeroBanner
        subtitle="SVERIGES SKARPASTE PRISER MED PRISGARANTI"
        title="Kläder för ökad samhörighet"
        copy="Med våra 20-års erfarenhet kan vi se till att skapa merch i hög kvalité oavsett om du är en skola, elevkår eller förening!"
        ctaLabel="Köp Skolmerch"
        ctaVariant="alternative"
        ctaIcon={<ArrowRight />}
        ctaOnClick={() => onMenuItemClick('menu_1')}
        image={require('../../../../assets/abc-se/landing/abc-hero-visual.png')}
        imageAlt="Studieresekläder"
        showCaption={false}
      />

      {/* ── USP / Trustpilot Bar ── */}
      <USP
        items={[
          { icon: 'fast-delivery', label: 'Snabb leverans' },
          { icon: 'size-guarantee', label: '100% storleksgaranti' },
          { icon: 'payment', label: 'Enkel individuell betalning' },
        ]}
        trustpilot={{
          businessUnitId: '46905da900006400050004f8',
          locale: 'sv-SE',
          reviewUrl: 'https://dk.trustpilot.com/review/cls.dk',
        }}
      />

      {/* ── Fullwidth Content Widget (offer + print specs, one block — the page shows
             no product grids; the shop is reached through the hero CTA / header) ── */}
      <Fullwidth
        subtitle="50.000+ ELEVER VÄLJER OSS VARJE ÅR"
        mainCopyVariant="h2"
        mainCopy="Vi erbjuder snabb leverans och attraktiva paketlösningar, och du kan beställa säkert med över 100 års erfarenhet."
        additionalCopy="Enkel individuell betalning. Fritt val av produkter"
        tags={['A4 ryggtryck', '10 × 10 cm bröstlogo', '2 tryckfärger per klass']}
        image={require('../../../../assets/abc-se/landing/about.jpg')}
        showHyperlink={false}
      />

      {/* ── Footer ── */}
      <Footer />
    </div>
  );
};

export default Landing;
